import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import MapPage from "@/pages/MapPage";
import SearchPage from "@/pages/SearchPage";
import BeachDetailPage from "@/pages/BeachDetailPage";
import StatePage from "@/pages/StatePage";
import CityPage from "@/pages/CityPage";
import DataDisclaimerPage from "@/pages/DataDisclaimerPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import SeoArticlePage from "@/pages/SeoArticlePage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import AccessibilityStatementPage from "@/pages/AccessibilityStatementPage";

// Components
import Navbar from "@/components/Navbar";
import AccessibilityWidget from "@/components/AccessibilityWidget";

function App() {
  // Remove Emergent badge
  useEffect(() => {
    const removeBadge = () => {
      const badge = document.getElementById("emergent-badge");
      if (badge) {
        badge.remove();
      }
    };
    removeBadge();
    const interval = setInterval(removeBadge, 500);
    setTimeout(() => clearInterval(interval), 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-gradient-to-b from-sky-50 to-amber-50">
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/map" element={<MapPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/beach/:slug" element={<BeachDetailPage />} />
            <Route path="/state/:stateSlug" element={<StatePage />} />
            <Route path="/state/:stateSlug/:citySlug" element={<CityPage />} />
            <Route path="/data-disclaimer" element={<DataDisclaimerPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/accessibility-statement" element={<AccessibilityStatementPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/contact" element={<ContactPage />} />
            {/* SEO Article Pages - All States */}
            <Route path="/:stateSlug/:articleType/:citySlug" element={<SeoArticlePage />} />
          </Routes>
          <AccessibilityWidget />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
